import { render, staticRenderFns } from "./CartOrderType.vue?vue&type=template&id=1757771a&scoped=true"
import script from "./CartOrderType.vue?vue&type=script&lang=js"
export * from "./CartOrderType.vue?vue&type=script&lang=js"
import style0 from "./CartOrderType.vue?vue&type=style&index=0&id=1757771a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1757771a",
  null
  
)

export default component.exports